import Toggle from './Toggle';
import ToggleSmall from './Toggle-small';

export default Toggle;
export {ToggleSmall};